import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopyIcon } from '@primer/octicons-react';
import { StyledOcticon } from '@primer/react';
import { useToastContext } from '../Toast/ToastContext';


export const BasicClipboardElement = ({ url }) => {
  const { showToast } = useToastContext();

  const onCopy = (text, copied) => {
    showToast(copied ? 'Copied to Clipboard!' : 'Could not copy to clipboard');
  }

  return (
    <CopyToClipboard text={url} onCopy={onCopy}>
      <button type="button">
        <StyledOcticon
          className="ml-1"
          icon={CopyIcon}
          size={16}
        />
      </button>
    </CopyToClipboard>
  )
}

export default BasicClipboardElement
